import ParameterErrors from '../errors/ParameterErrors';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class Feature{
	constructor(props){
		const {id, name, description}=props;
		this._id = id;
		this._name = name;
		this._description = description;
	}
	get id(){
		return this._id;
	}
	get name(){
		return this._name;
	}
	get description(){
		return this._description;
	}
}
